module.exports = __webpack_public_path__ + "static/media/4.356c09f9.JPG";